import { CustomerRmaType } from './customer.domain'

import { headers } from '../../utils/apiHeaders'
import { BACKEND_URL } from '../../config'
import handleResponse from '../../utils/handleApiResponse'

export const fetchCustomerView = (userId: string): Promise<CustomerRmaType[]> => {
  const URL_API_FAQ_REQUEST = `${BACKEND_URL}/api/easy-rma/customer/${userId}/view`
  const requestOptions = {
    method: 'GET',
    headers: headers(),
  }
  return fetch(URL_API_FAQ_REQUEST, requestOptions)
    .then(handleResponse)
    .then((data) => data as CustomerRmaType[])
}
